module.exports = __webpack_public_path__ + "static/media/jp_wco.a323c6d0.png";